export const style = {
  rowContainer: {
    sx: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
  },
  fallBack: {
    sx: {
      pr: 2,
    },
  },
  typography: {
    color: 'primary.text',
    fontWeight: 500,
  },
  boxNameCompany: {
    sx: {
      maxWidth: 200,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      color: 'primary.text',
      fontWeight: 500,
    },
  },
  row: {
    sx: {
      display: 'flex',
      alignItems: 'center',
    },
    linkedinBox: {
      link: {
        margin: '0px 8px',
        height: '24px',
      },
      sx: {
        display: 'flex',
        alignItems: 'center',

      },
    },
  },
} as const;
